import script from "./RecipientDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipientDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__